import { useEffect, useRef } from "react";
import { InputForm } from "src/components/common/form/input/InputForm";

interface Props {
	value: string;
	setSearch: (search: string) => void;
	onSearch: () => void;
	autoFocus?: boolean;
	wrapperStyle?: {
		wrapperStyle: string;
		titleStyle: string;
		inputStyle: string;
	};
}

export const SearchForm = (props: Props) => {
	const { 
		value,
		setSearch,
		onSearch,
		autoFocus = true,
		wrapperStyle = {
			wrapperStyle: "flex flex-1 mb-[5px]",
			titleStyle: "w-[80px] min-w-[80px]",
			inputStyle: "flex-1"
		}
	} = props;

	const searchRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (autoFocus && searchRef.current) {
			searchRef.current.focus();
		}
	}, [autoFocus])

	const handleEnterKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') {
			onSearch();
		}
	}

	return (
		<div className={`w-full items-center gap-[8px] ${wrapperStyle.wrapperStyle}`}>
			<InputForm
				title="검색어" 	
				value={value}
				editable={true}
				wrapperStyle = {{
					wrapperStyle: "flex-1 mb-[5px]",
					titleStyle: "w-[70px] min-w-[70px] min-h-[28px]",
					inputStyle: "flex-1"
				}}
				name="search"
				onChange={(e) => setSearch(e.target.value)} 
				onKeyDown={handleEnterKeyDown}
				onLoadFocus={autoFocus}
			/>
		</div>
	)
}